/**
 * A "recent professional" row wraps the professional under a nested
 * `professional` object, while the row itself carries an unrelated record `id`.
 * The id used for selection/lookup is therefore `professional.id`, falling back
 * to the record `id`. Centralised here so this rule has a single source of truth
 * (its duplication across call sites is what caused GOTU-5686).
 */
interface IRecentProfessionalIdLike {
  id?: string;
  professional?: { id?: string } | null;
}

/** The id used to select/identify a recent professional (nested id, then record id). */
export const getRecentProfessionalId = (pro: {
  id: string;
  professional?: { id?: string } | null;
}): string => pro.professional?.id ?? pro.id;

/** True when `id` identifies this recent row by either its professional id or its record id. */
export const matchesRecentProfessional = (
  pro: IRecentProfessionalIdLike | null | undefined,
  id: string,
): boolean => pro?.id === id || pro?.professional?.id === id;
